import request from '@/utils/request'
import qs from 'qs'

export function initData(url, params, method) {
  let methods = method?method:'get'
  return request({
    url: url,
    method: methods,
    params: methods == 'get'?params:undefined,
    data: methods == 'post'?params:undefined
  })
}
export function getMsgCount(data) {
  return request({
    url: '/api/system/systemMessage/getCount',
    method: 'get',
    params:data
  })
}
export function getMsgList(data) {
  return request({
    url: '/api/system/systemMessage',
    method: 'get',
    params:data
  })
}
export function delMsg(id) {
  return request({
    url: `/api/system/systemMessage/${id}`,
    method: 'delete'
  })
}
export function refreshMsgList() {
  return request({
    url: '/api/system/systemMessage/refresh',
    method: 'get'
  })
}
export function getDeviceOfflineList(data) {
  return request({
    url: '/api/system/systemMessage/getDeviceOfflineList',
    method: 'get',
    params:data
  })
}
export function download(url, params) {
  return request({
    url: url + '?' + qs.stringify(params, { indices: false }),
    method: 'get',
    responseType: 'blob'
  })
}


/**
 * 月卡未续费原因
 * @param data
 * @returns {*}
 */
export function reviewMonthCardRenewal(data) {
  return request({
    url: `/api/system/systemMessage/review`,
    method: 'post',
    data: data
  })
}